<template>
    <page-container2 title="业务账单统计" showRefreshBtn @refresh="refresh">
        <template v-slot:buttons>
            <permission-container permissionId="Erp.BizBillStat.Create">
                <el-button type="primary" size="mini" @click="showCreateDialog">新增账单统计</el-button>
            </permission-container>
        </template>
        <permission-container showTip permissionId="Erp.BizBillStat.List">
            <search-form class="search-form-card" :table-list="tableList">
                <template v-slot:form-items>
                    <el-form-item >
                        <el-date-picker
                            style="width: 240px;"
                            v-model="tableList.searchForm.month"
                            type="month"
                            placeholder="选择账单月份"
                            @change="onMonthChange"
                            value-format="yyyy-MM">
                        </el-date-picker>
                    </el-form-item>
                </template>
            </search-form>
            <pagination-table
            ref="listTable"
            :tableList="tableList"
            showCloseBtn
            >
            <template v-slot:tableColumns>
                <el-table-column
                    type="index"
                    label="序号"
                    width="100"
                    align="center"
                    >
                </el-table-column>
                <!-- <el-table-column
                    prop="name"
                    label="客户名称">
                    <template slot-scope="scope">
                        <div>{{scope.row.customerName}}（{{scope.row.customerCode}}）</div>
                    </template>
                </el-table-column> -->
                <el-table-column
                    prop="month"
                    width="120"
                    label="月份">
                </el-table-column>
                <el-table-column
                    prop="month"
                    label="统计周期">
                    <template slot-scope="scope">
                        <div><date-render :value="scope.row.startDate"/> 至 <date-render :value="scope.row.endDate"/></div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="orderNum"
                    width="100"
                    label="订单数">
                </el-table-column>
                <el-table-column
                    prop="afterSaleNum"
                    width="100"
                    label="售后单数">
                </el-table-column>
                <el-table-column
                    prop="totalWeightNum"
                    width="150"
                    label="合计重量（Kg）">
                </el-table-column>
                <el-table-column
                    prop="totalPicNum"
                    width="150"
                    label="合计张数（张）">
                </el-table-column>
                <el-table-column
                    prop="totalAmount"
                    width="120"
                    label="合计金额">
                    <template slot-scope="scope">
                        <money-render :value="scope.row.totalAmount" :precision="2"/>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.createTime"/>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="150"
                    >
                    <template slot-scope="scope">
                        <permission-container permissionId="Erp.BizBillStat.Detail">
                            <el-button size="mini"
                            @click="detail(scope.row, scope.$index)">详情</el-button>
                        </permission-container>
                        <permission-container permissionId="Erp.BizBillStat.Delete">
                            <el-button
                            size="mini"
                            type="danger"
                            @click="deleteBizBill(scope.row, scope.$index)">删除</el-button>
                        </permission-container>
                        
                    </template>
                </el-table-column>
            </template>
            </pagination-table>
        </permission-container>
        <el-dialog title="新增账单统计" :visible.sync="createDialog" width="40%" :center="true">
            <el-form :model="form">
                <el-form-item label="对账单月份" :label-width="formLabelWidth">
                    <el-date-picker
                        style="width: 300px;"
                        v-model="form.month"
                        type="month"
                        placeholder="选择账单月份"
                        @change="onFormMonthChange"
                        value-format="yyyy-MM">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="对账单周期" :label-width="formLabelWidth">
                    <el-date-picker
                        style="width: 300px;"
                        v-model="form.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="onFormDateChange"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDialog = false">取 消</el-button>
                <el-button type="primary" @click="createBizBill" v-loading="isSubmitting">确 定</el-button>
            </div>
        </el-dialog>
    </page-container2>
    
</template>

<script>
import List from "@/components/table/List";

export default
{
    name: "BizBillStat",
    data()
    {
        return {
            tableList: new List({
                url: '/stats/bizbill/list',
                searchForm: {
                    customerId: null,
                    month: null,
                }
            }),
            form: {
                month: '',
                dateRange: [],
                startDate: '',
                endDate: ''
            },
            isSubmitting: false,
            createDialog: false,
            formLabelWidth: '120px',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    created()
    {
        console.log('list created');
    },
    mounted()
    {
        return this.refresh();
    },
    methods:
    {
        refresh()
        {
            return Fx.Promise.then(()=>
            {
                return this.$refs.listTable&&this.$refs.listTable.load();
            }).
            then(()=>
            {
                // return this.loadCount();
            });
        },
        handleSearchClients(keywords) {
            const search = () => {
                this.clientSelectLoading = true;
                this.clientPageList.searchForm.keywords = keywords;
                this.clientPageList.load().then(() =>
                {
                    this.clientSelectLoading = false;
                    return this.clientPageList.data;
                });
            };

            lodash.debounce(search, 300)();
        },
        onMonthChange(e) {
            this.tableList.searchForm.month = e;
        },
        detail(rowData) {
            let bridge = this.dispatchRouteTo('/erp/statement/bizbill/detail', {id: rowData.id});
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        },
        showCreateDialog(){ 
            this.createDialog = true;
        },
        createBizBill() {
            let data = {
                month: this.form.month,
                startDate: this.form.startDate,
                endDate: this.form.endDate
            }
            if(!this.form.month) {
                return this.showMessageError('请选择对账月份');
            }
            if(!this.form.startDate || !this.form.endDate) {
                return this.showMessageError('请选择对账周期');
            }
            this.isSubmitting = true;
            return Fx.Http.post('/stats/bizbill/createBizBill', data).
            then((resp)=>
            {
                this.loading = false;
                this.isSubmitting = false;
                if(resp.isSuccess() && resp.getData("id"))
                {
                    this.showMessageSuccess('新增成功');
                    this.form.customerId = null;
                    this.form.month = null;
                    this.form.startDate = null;
                    this.form.endDate = null;
                    this.form.dateRange = [];
                    this.refresh();
                    this.createDialog = false;
                    return true;
                }
                else
                {
                    this.showMessageError(resp.getErrorMessage());
                    return false;
                }
            });
        },
        onFormMonthChange(e){
            this.form.month = e;
        },
        onFormDateChange(e) {
            console.log(e)
            if(!e) {
                this.form.startDate = null;
                this.form.endDate = null;
                return;
            }
            this.form.startDate = e[0];
            this.form.endDate = e[1];
        },
        deleteBizBill(rowData, index)
        {
            console.log(rowData, index);
            return this.showConfirm("确定要删除吗？").
            then((result)=>{
                if(!result) return;
                return Fx.Http.post("/stats/bizbill/delete", {id: rowData.id}).
                then((resp)=>
                {
                    if(resp.isSuccess()) {
                        this.showMessageSuccess('删除成功', ()=>
                        {
                            this.tableList.load();
                        })
                    } else {
                        this.showMessageError(resp.getErrorMessage());
                    }
                })
            })
        },
    }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/statement/BizBillStat.vue